function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M24401.289 18987a2.294 2.294 0 0 1-2.291-2.291v-13.539a2.293 2.293 0 0 1 2.291-2.291h.834v-1.041a.835.835 0 0 1 1.67 0v1.041h2.293v-1.041a.832.832 0 1 1 1.664 0v1.041h2.293v-1.041a.832.832 0 1 1 1.664 0v1.041h.832a2.291 2.291 0 0 1 2.293 2.291v13.539a2.292 2.292 0 0 1-2.293 2.291zm.838-5.361a.831.831 0 0 0 .832.83h8.334a.833.833 0 1 0 0-1.666h-8.334a.834.834 0 0 0-.832.834zm0-3.336a.831.831 0 0 0 .832.832h8.334a.832.832 0 1 0 0-1.664h-8.334a.831.831 0 0 0-.832.829zm0-3.336a.832.832 0 0 0 .832.834h4.168a.833.833 0 0 0 0-1.666h-4.168a.833.833 0 0 0-.832.83z",
  transform: "translate(-24392.332 -18962)"
});

function SvgIconNotes1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes1);
export default __webpack_public_path__ + "static/media/icon_notes_1.e3b25c22.svg";
export { ForwardRef as ReactComponent };